import React, { memo } from 'react';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  product: IProduct;
}

const ProductDetails = ({ product }: IProps) => {
  return (
    <div className='flex max-sm:flex-col max-sm:text-center'>
      <div>
        <img
          className='block size-28.75 rounded-sm object-cover object-center max-sm:inline max-sm:size-50'
          src={product.image}
          alt='Preview'
        />
      </div>
      <div className='flex max-w-150 grow flex-col justify-center px-4 max-sm:px-0 max-sm:py-4'>
        <small className='mb-2'>#{product.id}</small>
        <strong>{product.title}</strong>
      </div>
    </div>
  );
};

export default memo(ProductDetails);
